import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import type TransferRefundForRefundOfRefundsViewModel from "viewModels/finance/refundForRefundOfRefunds/transferRefundForRefundOfRefunds/transferRefundForRefundOfRefundsViewModel";
import type RefundForRefundOfRefundResponse from "entities/refundForRefundOfRefundResponse";
import type { ListColumnDefinition } from "views/common/list";
import ListView from "views/common/list";
import { formatAmount, formatDate, formatLicensePlate } from "utils/localizations";
import TransferRefundForRefundOfRefundsFilters from "./transferRefundForRefundOfRefundsFilters";
import { ApprovalColumns } from "views/common/approvalColumns";
import { formatBankAccount } from "@edaz/utils/bankAccount";
import { emptyValue } from "utils/emptyValue";

export const TransferRefundForRefundOfRefundsView: ViewComponent<TransferRefundForRefundOfRefundsViewModel> = observer(
  ({ vm }) => {
    const columns: ListColumnDefinition<RefundForRefundOfRefundResponse>[] = [
      {
        title: vm.translateGeneral("licensePlate"),
        valueFormatter: ({ item }) => (item.charge ? formatLicensePlate(item.charge.vehicle) : emptyValue),
      },
      {
        title: vm.translateAttribute("originalPayment"),
        valueFormatter: ({ item }) => formatBankAccount(item.originalPayment?.senderBankAccount),
      },
      {
        title: vm.translate("variableSymbol"),
        valueFormatter: ({ item }) => (item.originalPayment ? item.originalPayment.variableSymbol : emptyValue),
      },
      {
        title: vm.translate("paidAmount"),
        valueFormatter: ({ item }) => (item.originalPayment ? formatAmount(item.originalPayment.paidAmount) : emptyValue),
      },
      {
        title: vm.translate("postingDate"),
        valueFormatter: ({ item }) => (item.originalPayment ? formatDate(item.originalPayment.postingDate) : emptyValue),
      },
      {
        property: "originalRefundOfficialRecordId",
        title: vm.translateAttribute("originalRefundOfficialRecordId"),
      },
      {
        title: vm.translate("refundPaymentType"),
        valueFormatter: ({ item }) => vm.translateRefundReason(item.refundPaymentTemplateId),
      },
      {
        property: "refundAmount",
        title: vm.translateAttribute("refundAmount"),
        valueFormatter: props => formatAmount(props.value),
      },
      ...ApprovalColumns<RefundForRefundOfRefundResponse, TransferRefundForRefundOfRefundsViewModel>(vm),
    ];

    return (
      <>
        <TransferRefundForRefundOfRefundsFilters vm={vm} />
        <ListView vm={vm} columns={columns} showDetailWithList={true} hideTitle={true} hideButtons={true} />
      </>
    );
  }
);
